var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8d46e"
    },
    d: "M134.954,124.605H16.998C7.613,124.605,0,132.218,0,141.603c0,4.698,1.906,8.942,4.976,12.022 c3.08,3.07,7.325,4.976,12.022,4.976h100.958c9.385,0,16.998,7.613,16.998,16.998c0,4.698-1.906,8.942-4.976,12.022 c-3.08,3.07-7.325,4.976-12.022,4.976H99.412c-9.385,0-16.998,7.613-16.998,16.998c0,4.698,1.906,8.942,4.976,12.022 c3.08,3.07,7.325,4.976,12.022,4.976h18.543c9.385,0,16.998,7.613,16.998,16.998c0,4.698-1.906,8.942-4.976,12.022 c-3.08,3.07-7.325,4.976-12.022,4.976H44.813c-9.385,0-16.998,7.613-16.998,16.998c0,4.698,1.906,8.942,4.976,12.022 c3.08,3.07,7.325,4.976,12.022,4.976h73.143c9.385,0,16.998,7.613,16.998,16.998c0,4.698-1.906,8.942-4.976,12.022 c-3.08,3.07-7.325,4.976-12.022,4.976H60.709c-9.529,0-17.616,7.798-17.441,17.328c0.175,9.23,7.716,16.668,16.998,16.668h74.688 h74.122c-0.177-0.188-0.35-0.378-0.526-0.566c0.341,0.064,0.526,0.098,0.526,0.098l77.665-0.515V124.137L134.954,124.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9bd38"
    },
    d: "M138.43,241.062c0,45.806,15.569,87.973,41.696,121.514h28.95c-0.177-0.188-0.35-0.378-0.526-0.566 c0.341,0.064,0.526,0.098,0.526,0.098l77.665-0.515V124.137l-110.326,0.34C152.535,157.179,138.43,197.471,138.43,241.062z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ede6f5"
    },
    cx: 336.354,
    cy: 241.062,
    r: 175.646
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0d3f2"
    },
    d: "M395.59,389.666c-97.002,0-175.646-78.644-175.646-175.646c0-59.294,29.389-111.725,74.39-143.531 c-76.71,18.836-133.626,88.056-133.626,170.573c0,97.002,78.644,175.646,175.646,175.646c37.708,0,72.638-11.888,101.255-32.115 C424.144,387.9,410.074,389.666,395.59,389.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ab9dd6"
    },
    d: "M511.413,226.64h-0.01H393.818h-114.58H161.653h-0.01c-0.391,4.759-0.587,9.57-0.587,14.423 c0,5.202,0.227,10.364,0.68,15.453h117.77H393.55h117.77c0.453-5.089,0.68-10.25,0.68-15.453 C512,236.21,511.804,231.399,511.413,226.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a095ce"
    },
    d: "M221.009,226.64h-59.356h-0.01c-0.391,4.759-0.587,9.57-0.587,14.423 c0,5.202,0.227,10.364,0.68,15.453h63.397C222.729,246.848,221.735,236.865,221.009,226.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fe4583"
    },
    d: "M336.354,65.416c-52.096,0-98.908,22.685-131.07,58.72c-24.735,27.702-40.805,63.284-43.989,102.503 h0.01h117.585h114.927h117.585h0.01C504.078,136.386,428.504,65.416,336.354,65.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc3268"
    },
    d: "M294.334,70.489c-0.658,0.159-1.312,0.33-1.969,0.496c-34.158,8.81-64.298,27.624-87.081,53.152 c-24.735,27.702-40.805,63.284-43.989,102.503h0.01h59.703c-0.302-4.169-0.465-8.375-0.465-12.62 C220.544,154.726,248.45,102.295,294.334,70.489z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4f4f74"
    },
    cx: 336.354,
    cy: 241.062,
    r: 59.235
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e436d"
    },
    d: "M378.374,275.739c-32.719,0-59.235-26.517-59.235-59.235c0-12.81,4.078-24.659,10.989-34.349 c-29.791,3.111-53.009,28.292-53.009,58.908c0,32.719,26.517,59.235,59.235,59.235c19.908,0,37.507-9.828,48.246-24.886 C382.554,275.626,380.478,275.739,378.374,275.739z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#32314b"
    },
    cx: 336.354,
    cy: 241.062,
    r: 32.451
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27273d"
    },
    d: "M355.248,261.042c-17.925,0-32.451-14.526-32.451-32.451c0-7.162,2.323-13.777,6.251-19.143 c-14.404,3.314-25.145,16.203-25.145,31.614c0,17.925,14.526,32.451,32.451,32.451c10.763,0,20.297-5.242,26.2-13.308 C360.205,260.746,357.761,261.042,355.248,261.042z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8d46e"
    },
    d: "M347.686,464.097c6.542,0,11.847,5.305,11.847,11.847c0,3.276-1.329,6.233-3.472,8.375 c-2.143,2.143-5.099,3.472-8.375,3.472h-87.565c-6.542,0-11.847-5.305-11.847-11.847c0-3.276,1.329-6.233,3.472-8.375 c2.143-2.143,5.099-3.472,8.375-3.472H347.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8d46e"
    },
    d: "M129.288,439.372c6.542,0,11.847,5.305,11.847,11.847c0,3.276-1.329,6.233-3.472,8.375 c-2.143,2.143-5.099,3.472-8.375,3.472H41.722c-6.542,0-11.847-5.305-11.847-11.847c0-3.276,1.329-6.233,3.472-8.375 c2.143-2.143,5.099-3.472,8.375-3.472H129.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8d46e"
    },
    d: "M32.451,192.129c9.385,0,16.998,7.613,16.998,16.998c0,4.698-1.906,8.942-4.976,12.022 c-3.08,3.07-7.325,4.976-12.022,4.976H16.998C7.613,226.125,0,218.512,0,209.127c0-4.698,1.906-8.942,4.976-12.022 c3.08-3.07,7.325-4.976,12.022-4.976H32.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8d46e"
    },
    d: "M225.095,24.209c7.685,0,13.907,6.222,13.907,13.907c0,3.843-1.556,7.314-4.069,9.838 c-2.524,2.514-5.996,4.069-9.838,4.069h-46.358c-7.685,0-13.907-6.222-13.907-13.907c0-3.843,1.556-7.314,4.069-9.838 c2.524-2.514,5.996-4.069,9.838-4.069H225.095z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.a91bc86fd946760bc17b6d9839065fa4.svg";
export { ForwardRef as ReactComponent };